import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_FAMILYCONTACTTYPE,
  DELETE_FAMILYCONTACTTYPE,
  UPDATE_FAMILYCONTACTTYPE,
  ADD_NEW_FAMILYCONTACTTYPE,
} from "./actionType";

import {
  getFamilyContactTypeSuccess,
  getFamilyContactTypeFail,
  deleteFamilyContactTypeSuccess,
  deleteFamilyContactTypeFail,
  updateFamilyContactTypeSuccess,
  updateFamilyContactTypeFail,
  addFamilyContactTypeSuccess,
  addFamilyContactTypeFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveFamilyContactTypeApi,
  getFamilyContactTypeApi,
  updateFamilyContactTypeApi,
  deleteFamilyContactTypeApi,
  addNewFamilyContactTypeApi
} from "../../helpers/backend_helper";

function* getFamilyContactType({ payload: familyContactType }) {
  try {
    const response = yield call(getFamilyContactTypeApi, familyContactType);
    yield put(getFamilyContactTypeSuccess(GET_FAMILYCONTACTTYPE, response.data));
  } catch (error) {
    yield put(getFamilyContactTypeFail(GET_FAMILYCONTACTTYPE, error));
  }
}

function* onUpdateFamilyContactType({ payload: familyContactType }) {
  try {
    const response = yield call(updateFamilyContactTypeApi, familyContactType);
    yield put(updateFamilyContactTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateFamilyContactTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteFamilyContactType({ payload: familyContactType }) {
  try {
    const response = yield call(deleteFamilyContactTypeApi, familyContactType);
    yield put(deleteFamilyContactTypeSuccess({ familyContactType, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteFamilyContactTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewFamilyContactType({ payload: familyContactType }) {
  try {
    const response = yield call(addNewFamilyContactTypeApi, familyContactType);
    yield put(addFamilyContactTypeSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addFamilyContactTypeFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetFamilyContactType() {
  yield takeEvery(GET_FAMILYCONTACTTYPE, getFamilyContactType);
}

export function* watchUpdateFamilyContactType() {
  yield takeEvery(UPDATE_FAMILYCONTACTTYPE, onUpdateFamilyContactType);
}

export function* watchDeleteFamilyContactType() {
  yield takeEvery(DELETE_FAMILYCONTACTTYPE, onDeleteFamilyContactType);
}

export function* watchAddNewFamilyContactType() {
  yield takeEvery(ADD_NEW_FAMILYCONTACTTYPE, onAddNewFamilyContactType);
}

function* familyContactTypeSaga() {
  yield all([
    fork(watchGetFamilyContactType),
    fork(watchDeleteFamilyContactType),
    fork(watchUpdateFamilyContactType),
    fork(watchAddNewFamilyContactType)
  ]);
}

export default familyContactTypeSaga;
